export default __webpack_public_path__ + "static/media/Inverse.034c659b.svg";